import { render, staticRenderFns } from "./finalModal.vue?vue&type=template&id=0edd184c&scoped=true"
import script from "./finalModal.vue?vue&type=script&lang=js"
export * from "./finalModal.vue?vue&type=script&lang=js"
import style0 from "./finalModal.vue?vue&type=style&index=0&id=0edd184c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd184c",
  null
  
)

export default component.exports